/**
 * Which build this is, shown on the splash screen.
 *
 * The service worker serves the bundle it already has and fetches the new one
 * in the background, so the restart after a deploy still shows the *previous*
 * build and only the restart after that shows the new one. That is how two
 * rounds of real changes can look, from a phone, like they did nothing — hence
 * something to read off the screen rather than infer.
 *
 * Vite replaces `__BUILD_ID__` at build time (see `vite.config.ts`). Nothing
 * replaces it under vitest or any other bare toolchain, so the `typeof` guard
 * is what keeps this from throwing there.
 */
declare const __BUILD_ID__: string | undefined;

export const BUILD_ID: string =
  typeof __BUILD_ID__ === "string" && __BUILD_ID__.length > 0 ? __BUILD_ID__ : "dev";
